import React from "react";
import { Link } from "react-router-dom";
import { ASSOC, POLES } from "@/lib/data";
import { getSiteSettings } from "@/lib/site";

const DEFAULT_INTRO = "Née en 2012, Heel'Events est une association culturelle du Val-de-Marne qui vit la danse comme un art de vivre : apprendre, progresser, se produire sur scène et partager. Autour de notre école Afrolat'Studio, nous réunissons enfants, ados et adultes, débutants et confirmés, dans une ambiance familiale et exigeante à la fois. Notre conviction : tout le monde peut danser, à son rythme, sans jugement.";

export default function Association() {
  const [settings, setSettings] = React.useState({});
  React.useEffect(() => { getSiteSettings().then(setSettings).catch(() => {}); }, []);
  const intro = settings.texts?.asso_intro || DEFAULT_INTRO;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
      <p className="he-overline text-neutral-500">L’association</p>
      <h1 className="font-heading text-5xl sm:text-6xl font-black tracking-tighter mt-3">Heel’Events</h1>
      <p className="mt-6 text-lg text-neutral-700 font-body max-w-2xl">
        {ASSOC.slogan}
      </p>

      {/* Qui sommes-nous */}
      <section data-testid="asso-qui-sommes-nous" className="mt-12 bg-black text-white rounded-2xl p-8 sm:p-10 he-grain">
        <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">Qui sommes-nous ?</h2>
        <p className="mt-5 text-white/80 font-body leading-relaxed max-w-3xl">{intro}</p>
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-6">
          {[
            ["2012", "Année de création"],
            ["3", "Villes dans le 94"],
            ["4", "Pôles artistiques"],
            ["10+", "Disciplines enseignées"],
          ].map(([n, l]) => (
            <div key={l}>
              <div className="font-heading text-4xl font-black text-[var(--he-red)]">{n}</div>
              <div className="mt-1 text-xs text-neutral-400 uppercase tracking-widest">{l}</div>
            </div>
          ))}
        </div>
      </section>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 font-body text-neutral-700">
        <p>
          Heel’Events est une association culturelle consacrée à la danse et aux arts de la scène, active depuis {ASSOC.since}.
          Elle propose des activités accessibles à différents publics : enfants, adolescents et adultes.
        </p>
        <p>
          Structure principale portant plusieurs projets, Heel’Events développe une école de danse (Afrolat’Studio), une compagnie artistique,
          des actions solidaires et un espace dédié aux artistes.
        </p>
      </div>

      <div className="mt-16 border-t border-black/10 pt-12">
        <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">Nos quatre pôles</h2>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {POLES.map((p) => (
            <Link key={p.slug} to={`/poles/${p.slug}`} className="p-6 border border-black/10 rounded-xl hover:border-[var(--he-red)] transition-colors">
              <div className="he-overline text-neutral-500">Pôle</div>
              <div className="font-heading text-xl font-bold mt-1">{p.name}</div>
              <p className="text-sm text-neutral-600 mt-2">{p.short}</p>
            </Link>
          ))}
        </div>
      </div>

      <div className="mt-16 border-t border-black/10 pt-12 grid grid-cols-1 md:grid-cols-3 gap-8 font-body">
        <div>
          <div className="he-overline text-neutral-500">Présidente</div>
          <div className="mt-2">{ASSOC.president}</div>
        </div>
        <div>
          <div className="he-overline text-neutral-500">Siège</div>
          <div className="mt-2">{ASSOC.address}</div>
        </div>
        <div>
          <div className="he-overline text-neutral-500">Contact</div>
          <div className="mt-2">{ASSOC.phone}</div>
          {ASSOC.emails.map(e => <div key={e} className="text-sm">{e}</div>)}
        </div>
      </div>
    </div>
  );
}
